import { type VariantProps, cva } from "class-variance-authority";
import type { ReactNode } from "react";

const badgeVariants = cva(
  "inline-flex w-fit shrink-0 items-center gap-1 whitespace-nowrap rounded-md border border-transparent px-2 py-0.5 text-xs font-medium",
  {
    variants: {
      tone: {
        brand: "bg-primary text-primary-foreground",
        neutral: "bg-secondary text-secondary-foreground",
        success: "bg-emerald-100 text-emerald-800 dark:bg-emerald-500/15 dark:text-emerald-300",
        warning: "bg-amber-100 text-amber-900 dark:bg-amber-500/15 dark:text-amber-300",
        danger: "bg-red-100 text-red-800 dark:bg-red-500/15 dark:text-red-300",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export function Badge({ tone, children }: VariantProps<typeof badgeVariants> & { children: ReactNode }) {
  return <span className={badgeVariants({ tone })}>{children}</span>;
}
